import { useState } from "react";
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import moment, { Moment } from "moment";
import Icon from "@mdi/react";

import { mdiAirplane, mdiFileChartOutline, mdiFileDownloadOutline, mdiSprout } from "@mdi/js";

import { useAuth } from "../../context/AuthContext";
import { generateESGPDF, generateVoosPDF } from "../../utils/pdfGenerator";
import ApiService from "../../services/ApiService";

import ListCard from "../../components/ListCard";
import Layout from "../../components/Layout";

export default function DashboardRelatorios() {
	const { user, cliente, handleLogout } = useAuth();
	const apiService = new ApiService(handleLogout);

	const [relatorioVoosModal, setRelatorioVoosModal] = useState(false);
	const [relatorioVoosDataInicial, setRelatorioVoosDataInicial] = useState<Moment | null>(moment().subtract(30, "days"));
	const [relatorioVoosDataFinal, setRelatorioVoosDataFinal] = useState<Moment | null>(moment().hours(23).minutes(59).seconds(59));
	const [relatorioVoosLoading, setRelatorioVoosLoading] = useState(false);
	const [relatorioConfig, setRelatorioConfig] = useState({
		pilotoResumo: true,
		pilotoVoos: true,
		pilotoTempo: true,
		droneResumo: true,
		droneVoos: true,
		droneTempo: true,
		missaoResumo: true,
		missaoVoos: true,
		missaoTempo: true,
		vooDetalhes: true,
	});

	const [relatorioESGModal, setRelatorioESGModal] = useState(false);
	const [relatorioESGDataInicial, setRelatorioESGDataInicial] = useState<Moment | null>(moment().subtract(30, "days"));
	const [relatorioESGDataFinal, setRelatorioESGDataFinal] = useState<Moment | null>(moment().hours(23).minutes(59).seconds(59));
	const [relatorioESGLoading, setRelatorioESGLoading] = useState(false);

	async function handleRelatorioVoos() {
		setRelatorioVoosLoading(true);
		try {
			const data = await apiService.GetLogsMissao(cliente!.id, undefined, undefined, undefined, relatorioVoosDataInicial!.valueOf(), relatorioVoosDataFinal!.valueOf());
			if (data?.Data) {
				generateVoosPDF({
					cliente: cliente!,
					user: user!,
					data: data.Data,
					dataInicial: relatorioVoosDataInicial!.format("DD/MM/YYYY"),
					dataFinal: relatorioVoosDataFinal!.format("DD/MM/YYYY"),
					config: relatorioConfig,
				});
			}
		} catch (e) {
			console.log(e);
		}
		setRelatorioVoosLoading(false);
		setRelatorioVoosModal(false);
	}

	async function handleRelatorioESG() {
		setRelatorioESGLoading(true);
		try {
			const data = await apiService.GetLogsMissao(cliente!.id, undefined, undefined, undefined, relatorioESGDataInicial!.valueOf(), relatorioESGDataFinal!.valueOf());
			if (data?.Data) {
				generateESGPDF({
					cliente: cliente!,
					user: user!,
					data: data.Data,
					dataInicial: relatorioESGDataInicial!.format("DD/MM/YYYY"),
					dataFinal: relatorioESGDataFinal!.format("DD/MM/YYYY"),
					config: relatorioConfig,
				});
			}
		} catch (e) {
			console.log(e);
		}
		setRelatorioESGLoading(false);
		setRelatorioESGModal(false);
	}

	return (
		<Layout>
			<h5 className="mt-3 mb-3 d-flex align-items-center fw-light flex-wrap" style={{ minHeight: 38 }}>
				<Icon path={mdiFileChartOutline} size={1} className="me-1" /> Relatórios
			</h5>

			<Row className="mb-4">
				<Col lg={6}>
					<ListCard
						onClick={() => {
							setRelatorioVoosModal(true);
						}}
					>
						<ListCard.Icon>
							<Icon path={mdiAirplane} size={1} className="text-muted me-3" />
						</ListCard.Icon>
						<ListCard.Content>
							<div className="flex-fill me-2">
								<div className="text-muted fw-lighter">Relatório de Voos</div>
								<div className="fw-light">Lista de voos por período</div>
							</div>
						</ListCard.Content>
						<ListCard.Action>
							<Icon path={mdiFileDownloadOutline} size={1} className="text-muted m-2" />
						</ListCard.Action>
					</ListCard>
				</Col>
				<Col lg={6}>
					<ListCard
						onClick={() => {
							setRelatorioESGModal(true);
						}}
					>
						<ListCard.Icon>
							<Icon path={mdiSprout} size={1} className="text-muted me-3" />
						</ListCard.Icon>
						<ListCard.Content>
							<div className="flex-fill me-2">
								<div className="text-muted fw-lighter">Relatório ESG</div>
								<div className="fw-light">Uso de Drones vs. Veículos</div>
							</div>
						</ListCard.Content>
						<ListCard.Action>
							<Icon path={mdiFileDownloadOutline} size={1} className="text-muted m-2" />
						</ListCard.Action>
					</ListCard>
				</Col>
			</Row>

			{/* Relatório de Voos */}
			<Modal
				show={relatorioVoosModal}
				onHide={() => {
					setRelatorioVoosModal(false);
				}}
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Relatório de Voos</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{relatorioVoosLoading ? (
						<div className="d-flex justify-content-center align-items-center my-4">
							<Spinner className="me-2" />
							Gerando relatório...
						</div>
					) : (
						<>
							<Form.Group className="mb-3">
								<Form.Label>Período</Form.Label>
								<InputGroup>
									<InputGroup.Text className="bg-white px-2">
										<span className="small">De</span>
									</InputGroup.Text>
									<ReactDatePicker
										placeholderText="Data inicial e final"
										className="form-control small"
										calendarClassName="shadow-lg"
										popperClassName="react-datepicker-popper-custom"
										popperPlacement="bottom"
										onChange={(data) => {
											setRelatorioVoosDataInicial(data ? moment(data) : null);
										}}
										selectsStart={true}
										selected={relatorioVoosDataInicial?.toDate()}
										startDate={relatorioVoosDataInicial?.toDate()}
										endDate={relatorioVoosDataFinal?.toDate()}
										maxDate={relatorioVoosDataFinal?.toDate() ?? moment().toDate()}
										dateFormat="dd/MM/yyyy"
										dropdownMode="select"
									/>
									<InputGroup.Text className="bg-white px-2">
										<span className="small">Até</span>
									</InputGroup.Text>
									<ReactDatePicker
										placeholderText="Data inicial e final"
										className="form-control small"
										calendarClassName="shadow-lg"
										popperClassName="react-datepicker-popper-custom"
										popperPlacement="bottom"
										onChange={(data) => {
											setRelatorioVoosDataFinal(data ? moment(data) : null);
										}}
										selectsEnd={true}
										selected={relatorioVoosDataFinal?.toDate()}
										startDate={relatorioVoosDataInicial?.toDate()}
										endDate={relatorioVoosDataFinal?.toDate()}
										minDate={relatorioVoosDataInicial?.toDate() ?? moment().toDate()}
										maxDate={moment().toDate()}
										dateFormat="dd/MM/yyyy"
										dropdownMode="select"
									/>
								</InputGroup>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Pilotos</Form.Label>
								<div className="d-flex justify-content-between">
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`piloto-resumo`}
										label={`Resumo`}
										checked={relatorioConfig.pilotoResumo}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, pilotoResumo: e.target.checked })}
									/>
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`piloto-voos`}
										label={`Voos por Mês`}
										checked={relatorioConfig.pilotoVoos}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, pilotoVoos: e.target.checked })}
									/>
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`piloto-tempo`}
										label={`Tempo por Mês`}
										checked={relatorioConfig.pilotoTempo}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, pilotoTempo: e.target.checked })}
									/>
								</div>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Drones</Form.Label>
								<div className="d-flex justify-content-between">
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`drone-resumo`}
										label={`Resumo`}
										checked={relatorioConfig.droneResumo}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, droneResumo: e.target.checked })}
									/>
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`drone-voos`}
										label={`Voos por Mês`}
										checked={relatorioConfig.droneVoos}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, droneVoos: e.target.checked })}
									/>
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`drone-tempo`}
										label={`Tempo por Mês`}
										checked={relatorioConfig.droneTempo}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, droneTempo: e.target.checked })}
									/>
								</div>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Missões</Form.Label>
								<div className="d-flex justify-content-between">
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`missao-resumo`}
										label={`Resumo`}
										checked={relatorioConfig.missaoResumo}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, missaoResumo: e.target.checked })}
									/>
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`missao-voos`}
										label={`Voos por Mês`}
										checked={relatorioConfig.missaoVoos}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, missaoVoos: e.target.checked })}
									/>
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`missao-tempo`}
										label={`Tempo por Mês`}
										checked={relatorioConfig.missaoTempo}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, missaoTempo: e.target.checked })}
									/>
								</div>
							</Form.Group>

							<Form.Group className="mb-3">
								<Form.Label>Voos</Form.Label>
								<div className="d-flex justify-content-between">
									<Form.Check
										type={"checkbox"}
										className="d-inline-flex gap-2"
										id={`voo-resumo`}
										label={`Detalhes dos Voos`}
										checked={relatorioConfig.vooDetalhes}
										onChange={(e) => setRelatorioConfig({ ...relatorioConfig, vooDetalhes: e.target.checked })}
									/>
								</div>
							</Form.Group>
						</>
					)}
				</Modal.Body>
				{!relatorioVoosLoading && (
					<Modal.Footer>
						<Button
							variant="secondary"
							onClick={() => {
								setRelatorioVoosModal(false);
							}}
						>
							Cancelar
						</Button>
						<Button onClick={handleRelatorioVoos}>Gerar</Button>
					</Modal.Footer>
				)}
			</Modal>

			{/* Relatório ESG */}
			<Modal
				show={relatorioESGModal}
				onHide={() => {
					setRelatorioESGModal(false);
				}}
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Relatório ESG</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{relatorioESGLoading ? (
						<div className="d-flex justify-content-center align-items-center my-4">
							<Spinner className="me-2" />
							Gerando relatório...
						</div>
					) : (
						<>
							<Form.Group className="mb-3">
								<Form.Label>Período</Form.Label>
								<InputGroup>
									<InputGroup.Text className="bg-white px-2">
										<span className="small">De</span>
									</InputGroup.Text>
									<ReactDatePicker
										placeholderText="Data inicial e final"
										className="form-control small"
										calendarClassName="shadow-lg"
										popperClassName="react-datepicker-popper-custom"
										popperPlacement="bottom"
										onChange={(data) => {
											setRelatorioESGDataInicial(data ? moment(data) : null);
										}}
										selectsStart={true}
										selected={relatorioESGDataInicial?.toDate()}
										startDate={relatorioESGDataInicial?.toDate()}
										endDate={relatorioESGDataFinal?.toDate()}
										maxDate={relatorioESGDataFinal?.toDate() ?? moment().toDate()}
										dateFormat="dd/MM/yyyy"
										dropdownMode="select"
									/>
									<InputGroup.Text className="bg-white px-2">
										<span className="small">Até</span>
									</InputGroup.Text>
									<ReactDatePicker
										placeholderText="Data inicial e final"
										className="form-control small"
										calendarClassName="shadow-lg"
										popperClassName="react-datepicker-popper-custom"
										popperPlacement="bottom"
										onChange={(data) => {
											setRelatorioESGDataFinal(data ? moment(data) : null);
										}}
										selectsEnd={true}
										selected={relatorioESGDataFinal?.toDate()}
										startDate={relatorioESGDataInicial?.toDate()}
										endDate={relatorioESGDataFinal?.toDate()}
										minDate={relatorioESGDataInicial?.toDate() ?? moment().toDate()}
										maxDate={moment().toDate()}
										dateFormat="dd/MM/yyyy"
										dropdownMode="select"
									/>
								</InputGroup>
							</Form.Group>
						</>
					)}
				</Modal.Body>
				{!relatorioVoosLoading && (
					<Modal.Footer>
						<Button
							variant="secondary"
							onClick={() => {
								setRelatorioESGModal(false);
							}}
						>
							Cancelar
						</Button>
						<Button onClick={handleRelatorioESG}>Gerar</Button>
					</Modal.Footer>
				)}
			</Modal>
		</Layout>
	);
}
